import React from 'react'
import PropTypes from 'prop-types'
import { motion, useScroll } from 'framer-motion'
import styled from 'styled-components'

import PageTitle from '../common/PageTitle'
import { SmallHero } from '../admin/page/page_builder/components/small-hero/SmallHero'
import { Container, NavbarPadding, VerticalPad } from '../theme/default/base'

export const LegalDisplay = ({ title, content }) => {
  const { scrollYProgress } = useScroll()
  return (
    <NavbarPadding style={{ position: 'relative' }}>
      <Progress style={{ scaleX: scrollYProgress }} />
      <PageTitle title={title} />
      <Container>
        <VerticalPad>
          <SmallHero title={title} has_cta={false} />
          <div
            dangerouslySetInnerHTML={{
              __html: content
            }}
          />
        </VerticalPad>
      </Container>
    </NavbarPadding>
  )
}

LegalDisplay.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string
}

export default LegalDisplay

const Progress = styled(motion.div)`
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  height: 5px;
  background: ${(props) => props.theme.colors.primary};
  transform-origin: 0%;
`
